import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormService {
  constructor(private readonly fb: FormBuilder) {}

  createFormGroup(
    controls: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    options?: AbstractControlOptions | null
  ): FormGroup {
    return this.fb.group(controls, options);
  }

  createFormArray(
    controls: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ): FormArray {
    return this.fb.array(controls);
  }

  getFormGroup(form: FormGroup, key: string): FormGroup {
    return form.controls[key] as FormGroup;
  }

  getFormArray(form: FormGroup, key: string): FormArray {
    return form.controls[key] as FormArray;
  }
  clearFormArray(formArry: FormArray) {
    while (formArry.length !== 0) {
      formArry.removeAt(0);
    }
  }
}
